import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Employees from "./Employees";
import StaffManagement from "./StaffManagement";

/**
 * Unified People page — merges "Employees" (CRUD / roster) and
 * "Staff & QR" (QR codes + shift history) into a single tabbed screen.
 * The sidebar now links here instead of the two legacy pages.
 */
export default function People() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "roster";

  return (
    <div className="p-4 md:p-8 max-w-7xl">
      <div className="mb-6">
        <div className="label-caps text-muted-foreground mb-2">Operations</div>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">People</h1>
        <p className="text-sm text-muted-foreground mt-2">Manage your team, print QR cards, and track shifts.</p>
      </div>

      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })} className="w-full">
        <TabsList className="mb-6" data-testid="people-tabs">
          <TabsTrigger value="roster" data-testid="people-tab-roster">Roster</TabsTrigger>
          <TabsTrigger value="qr" data-testid="people-tab-qr">QR &amp; Shifts</TabsTrigger>
        </TabsList>
        <TabsContent value="roster" className="mt-0">
          <div className="people-embedded"><Employees embedded /></div>
        </TabsContent>
        <TabsContent value="qr" className="mt-0">
          <div className="people-embedded"><StaffManagement embedded /></div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
